import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "notification-inquiry-paid",
  "use": "notification-inquiry-paid-usage",
  "viewBox": "0 0 20.125 14.094",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20.125 14.094\" id=\"notification-inquiry-paid\">\n  <path fill-rule=\"evenodd\" d=\"M576.774,394.385H562.516a1.67,1.67,0,0,0-1.677,1.66v8.3A1.67,1.67,0,0,0,562.516,406h14.258a1.671,1.671,0,0,0,1.678-1.659v-8.3A1.672,1.672,0,0,0,576.774,394.385Zm0,9.956H562.516v-8.3h14.258v8.3Zm-8.387-.83H570.9a3.319,3.319,0,1,0,0-6.637h-2.516A3.319,3.319,0,1,0,568.387,403.511Zm0-4.978H570.9a1.66,1.66,0,1,1,0,3.319h-2.516A1.66,1.66,0,1,1,568.387,398.533Zm10.9-6.637H565.032a1.671,1.671,0,0,0-1.677,1.66H579.29v9.955a1.671,1.671,0,0,0,1.678-1.659v-8.3A1.672,1.672,0,0,0,579.29,391.9Z\" transform=\"translate(-560.844 -391.906)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/notification-inquiry-paid.svg
// module id = null
// module chunks = 